import {
	Box,
	Chip,
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	SelectChangeEvent,
	Theme,
} from "@mui/material"
import { useTheme } from "@mui/material/styles"
import { useTranslation } from "react-i18next"

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8

const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250,
		},
	},
}

interface IchannelType {
	name: string
	bgColor: string
	color: string
}

const channelType: IchannelType[] = [
	{
		name: "EMAIL",
		bgColor: "#98bd0a",
		color: "#333",
	},
	{
		name: "SMS",
		bgColor: "#007a4d",
		color: "#FFF",
	},
	{
		name: "WHATSAPP",
		bgColor: "#464646",
		color: "#FFF",
	},
]

function getStyles(
	name: string,
	channelSelected: readonly [IchannelType],
	theme: Theme
) {
	return {
		fontWeight: channelSelected.includes(name)
			? theme.typography.fontWeightRegular
			: theme.typography.fontWeightMedium,
	}
}

interface IChannelMultiSelectProps {
	channelSelected: string[]
	setChannelSelected: (channelList: string[]) => void
}

const ChannelPlickMultiSelect = ({
	channelSelected,
	setChannelSelected,
}: IChannelMultiSelectProps) => {
	const theme = useTheme()
	const { t } = useTranslation()
	const handleChange = (event: SelectChangeEvent<typeof channelSelected>) => {
		const {
			target: { value },
		} = event

		setChannelSelected(
			// On autofill we get a stringified value.
			typeof value === "string" ? value.split(",") : value
		)
	}

	return (
		<FormControl sx={{ margin: 0, width: "100%" }} variant="standard">
			<InputLabel shrink={true} id="channel-plick-multiple-chip-label">
				{t("channel", { ns: "plick" })}
			</InputLabel>
			<Select
				labelId="channel-plick-multiple-chip-label"
				id="channel-plick-multiple-chip"
				variant="standard"
				multiple
				value={channelSelected}
				onChange={handleChange}
				// input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
				renderValue={(selectedArray: string[]) => {
					const displayArray = selectedArray.slice(0, 2)
					const remainingCount = selectedArray.length - displayArray.length
					return (
						<Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
							{displayArray.map((value) => (
								<Chip
									key={value}
									label={value}
									sx={{
										color: channelType.find((channel) => channel.name === value)
											?.color,
										backgroundColor: channelType.find(
											(channel) => channel.name === value
										)?.bgColor,
									}}
								/>
							))}
							{remainingCount > 0 && <Chip label={`+${remainingCount}`} />}
						</Box>
					)
				}}
				MenuProps={MenuProps}
			>
				{channelType.map((currentChannel: IchannelType) => (
					<MenuItem
						key={currentChannel.name}
						value={currentChannel.name}
						style={getStyles(currentChannel.name, channelSelected, theme)}
					>
						{currentChannel.name}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	)
}

export default ChannelPlickMultiSelect
